/**
 * The name of the general planting wishlist element. Note that the text may not
 * be an exact match if the element has '(*Selection Required) within it.
 */
export const GENERAL_PLANTING_ELEMENT = "General Planting";
